import React, { Component } from "react";
import Container from "semantic-ui-react/dist/commonjs/elements/Container";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import Header from "semantic-ui-react/dist/commonjs/elements/Header";
import Tab from "semantic-ui-react/dist/commonjs/modules/Tab";
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import resources from "../resources";
import MainMenu from "../components/MainMenu.component";
import "../styles/OrderList.css";
import OrderRowTable from "../containers/OrderRowTable.container";
import { int32 } from "../constants/int.constants";

class OrderList extends Component {
  render() {
    return (
      <div>
        <MainMenu
          history={this.props.history}
          location={this.props.location}
          user={this.props.user}
          navigate={this.props.navigate}
        />

        <Container fluid className="main">
          <Grid columns={1} relaxed padded stackable>
            <Grid.Row>
              <Grid.Column>
                <Header
                  as="h3"
                  color="red"
                  className="finnid-header orderlist-header"
                >
                  {resources.ORDER_LISTS}
                </Header>

                <Tab
                  attached="top"
                  panes={[
                    {
                      menuItem: resources.CURRENT_STATE,
                      render: () => (
                        <Segment attached="bottom">
                          <OrderRowTable
                            latest={true}
                            pageSize={int32.MAX}
                            create={!this.props.user.Roles.includes("Viewer")}
                            parentkey="latest_orderrow"
                            key="latest_orderrow"
                          />
                        </Segment>
                      ),
                    },
                    {
                      menuItem: resources.HISTORY,
                      render: () => (
                        <Segment attached="bottom">
                          <OrderRowTable
                            latest={false}
                            pageSize={27}
                            parentkey="history_orderrow"
                            key="history_orderrow"
                          />
                        </Segment>
                      ),
                    },
                  ]}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default OrderList;
